import dialog from "webmodals/dialog";

export default (body, title, size) =>
  dialog({
    body,
    title,
    size,
    buttons: {
      Confirm: {
        className: "btn btn-primary btn-confirmation"
      },
      Cancel: {
        dismiss: true,
        className: "btn-u-default",
      },
    },
  });
